<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <!-- Header -->
          <template #header>
            <div class="d-flex align-items-center">
              <strong class="mr-auto">
                OFD SMS/Email Notification Config
              </strong>
              <div>
                <b-button variant="success" @click="toggleForm">
                  Add Configuration
                </b-button>
                <b-button variant="info" class="ml-2"  @click="toggleCsvUpload">
                  Bulk CSV Upload
                </b-button>
                <b-button
                    variant="warning"
                    class="ml-2"
                    @click="showSearch=!showSearch">
                    Filter / Search
                </b-button>
               <!-- <b-button variant="primary" @click="triggerOFDMail"  :disabled="isBusy1">
                  <b-spinner small v-if="isBusy1"></b-spinner>
                  {{ isBusy1 ? "Sending..." : "Corn Trigger OFD Mail" }}
              </b-button>
              <b-button variant="success" @click="triggerOFDSMS" :disabled="isBusy">
                 Corn Trigger OFD SMS
              </b-button>-->
              <b-button variant="warning" class="ml-2"  @click="openNotificationLog">
                  Notification Log
              </b-button>

              </div>
            </div>
          </template>
          <!-- Add Configuration -->
          <div
            ref="editForm"
            class="form-container"
            :class="{ 'highlight-form': highlightForm }">
            <div class="form-title">
              {{ editMode ? 'Edit Configuration' : 'Add Configuration' }}
            </div>
            <b-row>
              <!-- User -->
              <b-col md="4">
                <b-form-group label="Select User ID">
                  <v-select
                    v-model="valueUser"
                    :options="optionsUser"
                    label="label"
                    placeholder="Select User ID"
                  />
                </b-form-group>
              </b-col>

              <!-- SMS -->
              <b-col md="3">
                <b-form-group label="IS OFD SMS">
                  <b-form-select
                    v-model="valueSms"
                    :options="yesNoOptions">
                  </b-form-select>
                </b-form-group>
              </b-col>


              <!-- Email -->
              <b-col md="3">
                <b-form-group label="IS OFD Email">
                  <b-form-select
                    v-model="valueEmail"
                    :options="yesNoOptions">
                  </b-form-select>
                </b-form-group>
              </b-col>


              <!-- Active -->
              <b-col md="2">
                <b-form-group label="IS Active">
                  <b-form-select
                    v-model="isActive"
                    :options="activeinactiveOptions">
                  </b-form-select>
                </b-form-group>
              </b-col>


              <!-- Buttons -->
              <b-col md="4" class="mt-4">
              <b-button
                  variant="primary"
                  @click="saveConfiguration"
              >
                  {{ editMode ? 'Update' : 'Submit' }}
              </b-button>
                <b-button variant="secondary" class="ml-2" @click="resetForm">
                  Reset
                </b-button>
              </b-col>
            </b-row>
          </div>

          <!-- Bulk Upload -->
          <div
            v-if="showCsvUpload"
            class="form-container">
            <div class="form-title">
              Upload Configuration
            </div>
            <b-row>
              <b-col md="7">
                <b-row>
                  <b-col md="3">
                    <label>
                      <b>Upload CSV File</b>
                    </label>
                    <span style="color:red">*</span>
                  </b-col>
                  <b-col md="8">
                    <b-form-group>
                      <b-form-file type="file" v-model="file" :state="Boolean(file)" @change="selectcsvFiletoUpload($event)"
                        placeholder="Upload CSV File" accept=".csv">
                      </b-form-file>
                    </b-form-group>
                   
                     <a
                        href="img/ofdNotification.csv"
                        download="ofdNotification.csv"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                    <br/>
                    <small class="text-muted">
                        Note: OFD Notification Configuration accepts only <b>1 (Yes)</b> or <b>0 (No)</b>.
                    </small>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="5">
                <b-row>
                  <b-col md="2">
                    <b-button variant="primary" @click="uploadcsv"  :disabled="isReadOnly">
                      Submit
                    </b-button>
                  </b-col>

                  <b-col md="2">
                    <b-button variant="danger" @click="clearcsv">
                      Clear
                    </b-button>
                  </b-col>

                  <b-col md="4">
                    <a :href="downlaodcsv + 'sysusermasterid=' + Usersysuser" target="_blank">
                      <b-button variant="primary">
                        Download Records
                      </b-button>
                    </a>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <!-- Search -->
          <div v-if="showSearch" class="form-container">
            <div class="form-title">
                Search Filters
            </div>
            <b-row>
                <b-col md="2">
                    <b-form-group label="User ID">
                        <b-form-input
                        v-model="searchUserId" placeholder="Enter User ID">
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="2">
                    <b-form-group label="Destination Name">
                        <b-form-input
                        v-model="searchDestinationName" placeholder="Enter Destination Name">
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="2">
                    <b-form-group label="Email">
                        <b-form-input
                        v-model="searchEmail" placeholder="Enter Email ID">
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="2">
                    <b-form-group label="Phone">
                        <b-form-input
                        v-model="searchPhone" placeholder="Enter Mobile Number">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="Active / Inactive">
                        <b-form-select
                        :options="yesNoFilterOptions"
                        v-model="searchActive">
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="IS OFD SMS">
                        <b-form-select
                        :options="yesNoNotificationOptions"
                        v-model="searchSms">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="2">
                    <b-form-group label="IS OFD Email">
                        <b-form-select
                        :options="yesNoNotificationOptions"
                        v-model="searchEmailFlag">
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="4" class="mt-4">
                    <b-button
                    variant="primary"
                    @click="listOfdNotificationData(1)">
                    Search
                    </b-button>
                    <b-button
                    variant="danger"
                    class="ml-2"
                    @click="resetSearch">
                    Reset
                    </b-button>
                </b-col>
            </b-row>
          </div>  

          <!-- Table -->
          <b-row>
            <b-col sm="12">
              <b>
                Total Records :<span style="color:red">{{ routertotalRows }}</span>
              </b>
              
              <b-table
                show-empty
                responsive
                :items="ofdNotificationResult"
                :fields="Routesdetailsfields"
                :busy="isBusy"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :bordered="bordered">
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template slot="is_active" slot-scope="row">
                  <span v-if="row.item.is_active=='Yes'">
                    Active
                  </span>
                  <span v-else>
                    Inactive
                  </span>
                </template>
                <template slot="is_ofd_sms" slot-scope="row">
                  <span v-if="row.item.is_ofd_sms">
                    YES
                  </span>
                  <span v-else>
                    NO
                  </span>
                </template>
                <template slot="is_ofd_email" slot-scope="row">
                  <span v-if="row.item.is_ofd_email">
                    YES
                  </span>
                  <span v-else>
                    NO
                  </span>
                </template>

                <template slot="action" slot-scope="row">
                  <b-button size="sm" @click="editinfoModal(row.item)"
                    style="background:#b0c4de !important;color:#000 !important;"
                    class="mb-1">
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>


          <!-- Pagination -->

          <b-row >
            <b-col sm="12" class="mt-3">
              <paginate
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'">
              </paginate>
            </b-col>
          </b-row>
        </b-card>

        <b-modal id="notificationLogModal" size="xl" title="OFD Notification Log" hide-footer  no-close-on-backdrop>
          <b-row>
              <b-col md="12">
                  <b-table
                      responsive
                      bordered
                      striped
                      hover
                      small
                      :busy="notificationBusy"
                      :items="notificationLogData"
                      :fields="notificationLogFields"
                      show-empty
                      empty-text="No data found."
                      >

                      <template #table-busy>
                          <div class="text-center text-danger">
                              <b-spinner small></b-spinner>
                              Loading...
                          </div>
                      </template>

                      <template slot="sms_sent" slot-scope="row" >

                          <span
                              class="badge badge-success"
                              v-if="row.item.sms_sent=='Sent'"
                          >
                              Sent 
                          </span>

                          <span
                              class="badge badge-danger"
                              v-else-if="row.item.sms_sent=='Failed'"
                          >
                              Failed
                          </span>

                          <span
                              class="badge badge-warning"
                              v-else
                          >
                              Pending
                          </span>

                      </template>

                      <template slot="email_sent" slot-scope="row"  >

                          <span
                              class="badge badge-success"
                              v-if="row.item.email_sent=='Sent'"
                          >
                              Sent
                          </span>

                          <span
                              class="badge badge-danger"
                              v-else-if="row.item.email_sent=='Failed'"
                          >
                              Failed
                          </span>

                          <span
                              class="badge badge-warning"
                              v-else
                          >
                              Pending
                          </span>

                      </template>

                      <template slot="action" slot-scope="row" >

                          <b-button
                              size="sm"
                              variant="info"
                              @click="viewSMSPayload(row.item)"
                          >
                              Payload
                          </b-button>

                          <b-button
                              size="sm"
                              class="ml-1"
                              variant="secondary"
                              @click="viewSMSResponse(row.item)"
                          >
                              Response
                          </b-button>

                      </template>

                  </b-table>
              </b-col>
          </b-row>
          <b-row>
              <b-col>
                  <paginate
                      :page-count="notificationNoOfPages"
                      :page-range="5"
                      :margin-pages="2"
                      :click-handler="notificationPagination"
                      :prev-text="'Prev'"
                      :next-text="'Next'"
                      :container-class="'pagination'"
                      :page-class="'page-item'">
                  </paginate>
              </b-col>
          </b-row>
        </b-modal>
        <b-modal id="payloadModal" title="SMS Payload" size="xl" hide-footer>
         <pre>{{selectedPayload}}</pre>
        </b-modal>
        <b-modal id="responseModal" title="SMS API Response" size="xl" hide-footer>
        <pre>{{selectedResponse}}</pre>
        </b-modal>


        <!-- Loader -->

        <div v-if="loading" class="overlay">
          <div class="loader"></div>
        </div>

      </b-col>
    </b-row>
  </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  data() {
    return {
      isBusy1: false,
      showSearch:false,
      showForm: false,
      showCsvUpload: false,
      editMode: false,
      editId: '',

      file1: null,
      selectcsvFile: '',
      file: '',
      selectFiletype: '',

      myToggle: false,
      downlaodcsv: '',

      Usersysuser: '',
      user_id: '',

      loading: false,
      isBusy: false,
      isReadOnly: false,

      pageNum: 1,
      listingpageno: 1,
      noofpages: '',
      routertotalRows: 0,

      accessBody: [],

      // table data
      ofdNotificationResult: [],

      // dropdown values
      valueUser: null,
      valueSms: true,
      valueEmail: true,
      isActive: 'Yes',

      // dropdown options
      optionsUser: [],

      yesNoOptions: [
        {
          text: "YES",
          value: true
        },
        {
          text: "NO",
          value: false
        }
      ],
       activeinactiveOptions: [
        {
          text: "YES",
          value: "Yes"
        },
        {
          text: "NO",
          value: "No"
        }
      ],

      // table fields
      Routesdetailsfields: [

        {
          key: 'userid',
          label: 'User ID',
          sortable: true
        },

        {
          key: 'destination_name',
          label: 'Destination Name',
          sortable: true
        },
        {
          key:'destination_emailid',
          label:'Email ID',
          sortable:true
        },
        {
          key:'destination_phone',
          label:'Phone',
          sortable:true
        },
        {
          key: 'is_active',
          label: 'Active / Inactive',
          sortable: true
        },
        

        {
          key: 'is_ofd_sms',
          label: 'IS OFD SMS',
          sortable: true
        },

        {
          key: 'is_ofd_email',
          label: 'IS OFD Email',
          sortable: true
        },

        {
          key: 'createdby',
          label: 'Created By',
          sortable: true
        },

        {
          key: 'createddate',
          label: 'Created Date',
          sortable: true,
          formatter: value => this.formatDate(value)

        },

        {
          key: 'modifiedby',
          label: 'Modified By',
          sortable: true
        },

        {
          key: 'modifieddate',
          label: 'Modified Date',
          sortable: true,
          formatter: value => this.formatDate(value)

        },

        {
          key: 'action',
          label: 'Actions',
          class: 'actionAdmin'
        }

      ],

      // table sorting
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      bordered: true,
      filter: '',
      searchUserId:'',
      searchDestinationName:'',
      searchEmail:'',
      searchPhone:'',
      searchActive:'',
      searchSms:'',
      searchEmailFlag:'',
      highlightForm: false,


      yesNoFilterOptions:[
          {text:'All',value:''},
          {text:'Active',value:'Yes'},
          {text:'Inactive',value:'No'}
      ],

      yesNoNotificationOptions:[
          {text:'All',value:''},
          {text:'YES',value:true},
          {text:'NO',value:false}
      ],
      notificationLogModal:false,
      notificationLogData:[],
      notificationLogFields:[
          {key:'notificationid',label:'ID',sortable:true},
          {key:'parentawb',label:'AWB'},
          {key:'userid',label:'User ID'},
          {key:'destinationcompanyname',label:'Destination'},
          {key:'destinationmobileno',label:'Mobile'},
          {key:'destinationemailid',label:'Email'},
          {key:'shipmentstatus',label:'Status'},
          {key:'sms_sent',label:'SMS'},
          {key:'email_sent',label:'Email'},
          {key:'smssendingstatus',label:'SMS Status'},
          {key:'createdon',label:'Created On'},
          {key:'action',label:'Action'}
      ],
      notificationTotalRows:0,
      notificationPageNo:1,
      notificationNoOfPages:0,
      notificationBusy:false,
      selectedPayload:'',
      selectedResponse:'',

    }

  },

  created() {

    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);

    this.userType = userInfo.user_type;
    this.Usersysuser = userInfo.sysusermasterid;
    this.user_id = userInfo.sysusermasterid;
    this.accessBody = userInfo.body;

    this.getalldata();

    this.listOfdNotificationData(this.pageNum);

    const csvurl =
      `${CONSTANTS.MIGRATION_API_URL}/downloadOFDNotificationConfigCSV?`;

    this.downlaodcsv = csvurl;

    this.ischeckbodyvalidation();

  },

 methods: {
    openNotificationLog() {
        this.notificationPageNo = 1;
        this.getNotificationLog(this.notificationPageNo);
        this.$bvModal.show("notificationLogModal");
    },
    getNotificationLog(pageNo) {
        this.notificationBusy = true;
        let userdata = JSON.parse(localStorage.getItem("userData"));
        let obj = {
            sysusermasterid: userdata.sysusermasterid,
            pageno: pageNo
        };
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getOFDNotificationLog`,obj).then(result => {
            this.notificationBusy = false;
            if(result.body.returnmsg=="Successful"){
                this.notificationLogData =result.body.returnvalue;
                this.notificationTotalRows =result.body.totalcount;
                this.notificationNoOfPages =Math.ceil(
                    this.notificationTotalRows / 10
                );
            }else{
                this.notificationLogData=[];
                this.notificationTotalRows=0;
                this.notificationNoOfPages=0;
            }
        }).catch(ex=>{
            this.notificationBusy=false;
            console.log(ex);
            this.$fire({
                type:"error",
                text:ex.message,
                timer:3000
            });
        });
    },
    notificationPagination(pageNo){
        this.notificationPageNo = pageNo;
        this.getNotificationLog(pageNo);
    },
    viewSMSPayload(item){
        if(item.smspayload==null){
            this.selectedPayload="No Payload Available";
        }else{
            try{
                this.selectedPayload =JSON.stringify(
                    JSON.parse(item.smspayload),
                    null,
                    4
                );
            }catch(ex){
                this.selectedPayload =item.smspayload;
            }
        }
        this.$bvModal.show("payloadModal");
    },
    viewSMSResponse(item){
        if(item.smsapiresponse==null){
            this.selectedResponse ="No Response Available";
        }else{
            try{
                this.selectedResponse =JSON.stringify(
                    JSON.parse(item.smsapiresponse),
                    null,
                    4
                );
            }catch(ex){
                this.selectedResponse =item.smsapiresponse;
            }
        }
        this.$bvModal.show("responseModal");
    },


 formatDate(value) {
        if (!value) return '';
        const d = new Date(value);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hour = String(d.getHours()).padStart(2, '0');
        const minute = String(d.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hour}:${minute}`;
    },
 async triggerOFDSMS() {
    try {
        let result = await this.$http.get(
            `${CONSTANTS.MIGRATION_API_URL}/triggerOFDSMS`
        );
        if (result.body.returnmsg == "Successful") {
            this.$fire({
                type: "success",
                text:`${result.body.returnvalue} Total : ${result.body.totalSMS}
                  Success : ${result.body.success}
                  Failed : ${result.body.failed}`,
                timer: 5000
            });
        } else {
            this.$fire({
                type: "error",
                text: result.body.returnvalue,
                timer: 5000
            });
        }

    } catch (ex) {
        this.$fire({
            type: "error",
            text: ex.message,
            timer: 5000
        });
    }
},
    async triggerOFDMail() {
        try {
            this.isBusy1 = true;
            const result = await this.$http.get(
                `${CONSTANTS.MIGRATION_API_URL}/triggerOFDMail`
            );
            this.isBusy1 = false;
            console.log(result.body);
            if (result.body.returnmsg === "Successful") {
                this.$fire({
                    title: "Success",
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 5000
                });
            } else {
                this.$fire({
                    title: "Error",
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 5000
                });
            }
        } catch (error) {
            this.isBusy1 = false;
            console.error(error);
            this.$fire({
                title: "Error",
                text: "Unable to trigger OFD Mail.",
                type: "error",
                timer: 5000
            });
        }
    },
    resetSearch(){
      this.searchUserId='';
      this.searchDestinationName='';
      this.searchEmail='';
      this.searchPhone='';
      this.searchActive='';
      this.searchSms='';
      this.searchEmailFlag='';
      this.listOfdNotificationData(1);
    },
    toggleForm() {
        this.editMode = false;
        this.showForm = !this.showForm;
        this.showCsvUpload = false;
        if (this.showForm) {
            this.resetForm();
        }
    },

    toggleCsvUpload() {
        this.showCsvUpload = !this.showCsvUpload;
        this.showForm = false;
        if (!this.showCsvUpload) {
            this.file = null;
        }
    },


    resetForm() {
        this.editMode = false;
        this.editId = '';
        this.valueUser = null;
        this.valueSms = true;
        this.valueEmail = true;
        this.isActive = 'Yes';
    },


    editinfoModal(item) {
        this.editMode = true;
        this.showForm = true;
        this.showCsvUpload = false;
         // Scroll to form
        this.$nextTick(() => {
          window.scrollTo({
              top: 0,
              behavior: "smooth"
          });

          const form = this.$refs.editForm;

          form.classList.remove("highlight-form");

          void form.offsetWidth;      // Force reflow

          form.classList.add("highlight-form");

      });
        this.editId = item.userid;
        this.valueUser = {
            label: item.destination_name + " - " + item.userid,
            value: item.userid
        };
        this.valueSms = item.is_ofd_sms === true || item.is_ofd_sms === 'true';
        this.valueEmail = item.is_ofd_email === true || item.is_ofd_email === 'true';
        this.isActive = item.is_active;
    },


    getalldata() {
        this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getStockistDestinationList`)
        .then(result => {
            if (result.body.returnmsg.toLowerCase() === "successful") {
                this.optionsUser = result.body.returnvalue.map(x => ({
                    label:`${x.destination_name} - ${x.destination_id}`,
                    value: x.destination_id
                }));
            }
        });
    },
    async saveConfiguration() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        if (!this.valueUser) {
            this.$fire({
                text: "Please Select User",
                type: "error",
                timer: 3000
            });
            return;
        }

        this.isBusy = true;
        let payload = {
            userid: this.valueUser.value,
            is_ofd_sms: this.valueSms,
            is_ofd_email: this.valueEmail,
            is_active: this.isActive,
            createdby: `${userInfo.sysemailid}`
        };
        if (this.editMode) {
            payload.editid = this.editId;
        }

        let apiUrl = this.editMode
            ? `${CONSTANTS.MIGRATION_API_URL}/updateOFDNotificationConfig`
            : `${CONSTANTS.MIGRATION_API_URL}/addOFDNotificationConfig`;

        try {
            this.$http.post(apiUrl, payload)
            .then(result => {
                this.isBusy = false;
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: this.editMode
                            ? "Updated Successfully"
                            : "Added Successfully",
                        type: "success",
                        timer: 3000
                    });
                    this.listOfdNotificationData(this.pageNum);
                    this.resetForm();
                }
                else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 3000
                    });
                }
            })
            .catch(ex => {
                this.isBusy = false;
                console.log(ex);
            });

        }
        catch (error) {
            this.isBusy = false;
            console.log(error);
        }
    },
    listOfdNotificationData(pageNo) {

      this.isBusy = true;

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

     const obj={
        sysusermasterid:userInfo.sysusermasterid,
        pageno:pageNo,
        userid:this.searchUserId,
        destination_name:this.searchDestinationName,
        destination_emailid:this.searchEmail,
        destination_phone:this.searchPhone,
        is_active:this.searchActive,
        is_ofd_sms:this.searchSms,
        is_ofd_email:this.searchEmailFlag
    }

      this.$http
      .post(
        `${CONSTANTS.MIGRATION_API_URL}/getOFDNotificationConfigData`,
        obj
      )
      .then(result => {

        this.isBusy = false;

        if (result.body.returnmsg === "Successful") {

          this.ofdNotificationResult = result.body.returnvalue;

          this.routertotalRows = result.body.totalcount;

          this.noofpages = parseInt(this.routertotalRows) / 10;

          this.noofpages = Math.ceil(this.noofpages);

        }
        else {

          this.ofdNotificationResult = [];

          this.routertotalRows = 0;

        }

      })
      .catch(ex => {

        this.isBusy = false;

        console.log(ex);

      });

    },


    clickCallback(pageNum) {

      this.listingpageno = pageNum;

      this.listOfdNotificationData(pageNum);

    },


    selectcsvFiletoUpload(event) {

      this.selectcsvFile = event.target.files[0];

      this.selectFiletype = event.target.files[0].type;

    },


    clearcsv() {

      this.file = '';
      this.selectcsvFile = '';
      this.selectFiletype = '';

    },


    uploadcsv() {

      var userdata = localStorage.getItem("userData");

      var userInfo = JSON.parse(userdata);
      console.log(this.selectFiletype)

      if (this.selectFiletype != 'text/csv' && this.selectFiletype != 'application/wps-office.xlsx') {

        this.$fire({

          text: "Please Upload CSV/XLSX File Only",

          type: "error",

          timer: 3000

        });

        return;

      }


      let data = new FormData();

      data.append('file', this.selectcsvFile);

      data.append(
        'createdby',
        `${userInfo.userfirstname} ${userInfo.userlastname}`
      );

      data.append(
        'sysusermasterid',
        `${userInfo.sysusermasterid}`
      );


      this.$http.post(

        `${CONSTANTS.MIGRATION_API_URL}/uploadOFDNotificationCSV`,
        data,

        {
          header: {
            'Content-Type': 'multipart/form-data'
          }
        }

      )
     .then(result => {
        if (result.body.returnmsg === "Successful") {

          const res = result.body;

         let message = `
            <b>Success Count :</b> ${res.successCount}<br>
            <b>Failed Count :</b> ${res.failedCount}<br><br>
            `;

            // if (res.success.length > 0) {
            //   message += '<b>Updated Successfully:</b><br>';

            //   res.success.forEach(item => {
            //     message += `• User ID : ${item.userid} - ${item.message}<br>`;
            //   });

            //   message += '<br>';
            // }

            if (res.failed.length > 0) {
              message += '<b>Failed:</b><br>';

              res.failed.forEach(item => {
                message += `• User ID : ${item.userid} - User ID Not Found <br>`;
              });
            }

            this.$fire({
              html: message,
              type: res.failedCount > 0 ? 'warning' : 'success',
              timer: 30000
            });

          this.file = '';
          this.selectcsvFile = '';
          this.selectFiletype = '';

          this.listOfdNotificationData(this.pageNum);
        }
        else {
          this.$fire({
            text: result.body.returnvalue,
            type: "error",
            timer: 30000
          });
        }
      })
      .catch(ex => {
        console.log(ex);
      });
    },


    ischeckbodyvalidation() {

      for (let i = 0; i < this.accessBody.length; i++) {

        const element = this.accessBody[i];

        if (element.child) {

          for (let j = 0; j < element.child.length; j++) {

            const k = element.child[j];

            if (
              k.title == 'OFD SMS/Email Config'
              &&
              k.isReadonly == true
            ) {

              this.isReadOnly = true;

            }

          }

        }

      }

    }

  }

}

</script>
<style scoped>
.highlight-form {
    border: 2px solid #007bff !important;
    background: #eef6ff !important;
    animation: highlight 1.5s ease;
}
.form-title.highlight {
    color: #0056b3;
    animation: pulseTitle 1.5s;
}

@keyframes highlight {

    0% {
        background: #fff3cd;
        border-color: #ffc107;
        transform: scale(1);
        box-shadow: 0 0 0 rgba(0,0,0,0);
    }

    30% {
        background: #d6ecff;
        border-color: #007bff;
        transform: scale(1.01);
        box-shadow: 0 0 12px rgba(0,123,255,.35);
    }

    100% {
        background: #eef6ff;
        border-color: #007bff;
        transform: scale(1);
        box-shadow: 0 0 0 rgba(0,0,0,0);
    }
    from {
        background: #fff9c4;
    }
    to {
        background: #eef6ff;
    }

}
.edit-mode {
    border: 2px solid #007bff;
    background: #eef6ff;
    animation: highlight 1.5s;
}


.form-container {
  border: 1px solid #dcdcdc;
  padding: 15px;
  border-radius: 5px;
  background: #fff;
  margin-bottom: 20px;
}

.form-title {
  font-size: 16px;
  font-weight: bold;
  color: #343a40;
  margin-bottom: 15px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
}

.actionAdmin {
  width: 80px;
  text-align: center;
}

.pagination {
  justify-content: center;
}

.page-item {
  margin: 0px 3px;
}

.page-item a {
  color: #20a8d8;
}

.page-item.active a {
  background-color: #20a8d8;
  border-color: #20a8d8;
  color: white;
}

.table td,
.table th {
  vertical-align: middle !important;
}

.table-responsive {
  min-height: 250px;
}

.badge-success {
  background-color: #28a745;
  color: #fff;
}

.badge-danger {
  background-color: #dc3545;
  color: #fff;
}

/* Loader Overlay */

.overlay {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255,255,255,0.7);
  z-index: 9999;
}

.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #20a8d8;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  transform: translate(-50%, -50%);
}

@keyframes spin {

  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }

}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
@keyframes pulseTitle {

    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.08);
        color: #dc3545;
    }

    100% {
        transform: scale(1);
    }

}

</style>